// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__KOcL9","divider":"style_divider__wWmD9"};